// DeleteAccountByEmail.jsx
// React component for deleting an account using only email (dummy delete mode)

import React, { useState } from 'react';
import './accountDelete.css';
import Logos from "../../myimgs/nivora 1.png"; 

export default function DeleteAccountByEmail() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [message, setMessage] = useState('');

  function validateEmail(e) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
    return re.test(String(e).toLowerCase());
  }

  const handleSubmit = (ev) => {
    ev.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email.');
      return;
    }
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setShowConfirm(true);
  };

  const sendDelete = () => {
    setShowConfirm(false);
    setLoading(true);
    setError('');
    setMessage('');

    // Simulate delete operation with a delay
    setTimeout(() => {
      setLoading(false);
      setMessage(`Account for ${email} deleted successfully!`);
      setEmail('');
    }, 1500); // 1.5s delay for effect
  };

  return (
    <div className="delete-container">
        <div className='myim'>
        <img src={Logos} alt="" />

        </div>
      <h2>Delete Account</h2>
      <p>Enter your email to delete your account. This action cannot be undone.</p>

      <form onSubmit={handleSubmit}>
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
        />

        {error && <div className="error">{error}</div>}
        {message && <div className="success">{message}</div>}

        <div className="button-group">
          <button type="submit" disabled={loading} className="delete-btn">
            {loading ? 'Processing...' : 'Delete Account'}
          </button>
          <button
            type="button"
            onClick={() => { setEmail(''); setError(''); setMessage(''); }}
            className="reset-btn"
            disabled={loading}
          >
            Reset
          </button>
        </div>
      </form>

      {showConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Confirm Delete</h3>
            <p>
              Are you sure you want to delete the account for <strong>{email}</strong>? 
              This cannot be undone.
            </p>
            <div className="modal-buttons">
              <button onClick={() => setShowConfirm(false)} className="cancel-btn">
                Cancel
              </button>
              <button onClick={sendDelete} className="confirm-btn">
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
